import React from "react";
import Todo from "./Todo";
import "./todo-list.css";
function TodoList({ todos, toggleComplete, removeTodo }) {
  return (
    <li>
      {todos.map((todo) => (
        <Todo
          key={todo.id}
          todo={todo}
          toggleComplete={toggleComplete}
          removeTodo={removeTodo}
        />
      ))}
    </li>
  );
}
export default TodoList;
